export const storageSaveDownload = (downloadId: string, count: number, ttl: number) =>
  localStorage.setItem(`download_${downloadId}`, JSON.stringify({ count, ttl }));

export const storageGetDownload = (downloadId: string): string | null =>
  localStorage.getItem(`download_${downloadId}`) as string | null;

export const storageRemoveDownload = (downloadId: string) => localStorage.removeItem(`download_${downloadId}`);

/** 登出/跳登录时保留 download_* 配额（非 X86 资源仍用前端计数；X86 试用/验证版由后端 save 限次） */
export const clearLocalStoragePreservingDownloadQuota = (): void => {
	const preserved: Record<string, string> = {};
	for (let i = 0; i < localStorage.length; i++) {
		const key = localStorage.key(i);
		if (key?.startsWith("download_")) {
			const val = localStorage.getItem(key);
			if (val != null) {
				preserved[key] = val;
			}
		}
	}
	localStorage.clear();
	Object.entries(preserved).forEach(([key, val]) => {
		localStorage.setItem(key, val);
	});
};

